import type { RightSummaryType } from '@/api/rights/types';
import { getGalileoExpResult } from '@/api/rights';
import { GalileoExpSceneEnum, GalileoExpStyleEnum } from '@/api/rights/types';
import { ubtSendError } from '@/shared/utils/ubt';
import { showPopupA, destroyPopupA } from './popupAService';
import { showPopupB, destroyPopupB } from './popupBService';

interface TabChangeRetainResult {
  retainSuccess?: boolean;
  submitClick?: boolean;
}
/** 是否展示最新版实验弹窗 */
export const showTabChangeRetain = async (
  params:
    {
      rightParams: RightSummaryType,
      goDetail: () => void,
      contractPreview: () => void,
    },
): Promise<TabChangeRetainResult> => {
  const {
    rightParams,
    goDetail,
    contractPreview,
  } = params;

  try {
    /** 获取实验结果 */
    const { isHitExp, style } = await getGalileoExpResult({
      expScene: GalileoExpSceneEnum.RIGHT_CARD_CHANGE_RETAIN_POP_1030_AB,
      loanCardType: rightParams.loanCardType,
      packageType: rightParams.packageType,
    });
    // 如果没命中实验 返回未命中实验
    if (!isHitExp) return Promise.resolve({});

    let result: TabChangeRetainResult = {
      retainSuccess: false,
      submitClick: false,
    };

    /** 样式B */
    if (style === GalileoExpStyleEnum.STYLE_B) {
      result = await showPopupB({
        rightParams, goDetail, contractPreview,
      });
    } else {
      // 样式A
      result = await showPopupA({ rightParams });
    }

    /** 获取用户选择结果  retainSuccess: true 表示用户选择保留权益，false 表示用户选择放弃权益 */
    /** applySubmit: false 表示不需要帮用户提交订单 */
    // 销毁弹窗
    destroyPopupB();
    destroyPopupA();

    return Promise.resolve(result);
  } catch {
    ubtSendError('getGalileoExpResult error when showTabChangeRetain');

    return Promise.resolve({});
  }
};
